export const PriceManagerAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'decimals',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'current',
        type: 'uint256',
      },
      { indexed: false, internalType: 'uint256', name: 'min', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'max', type: 'uint256' },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'updatedAt',
        type: 'uint256',
      },
    ],
    name: 'PricesUpdated',
    type: 'event',
  },
  {
    inputs: [],
    name: 'PRICE_MANAGER_ADMIN_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'defaultUniswapPeriod',
    outputs: [{ internalType: 'uint32', name: '', type: 'uint32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fissionUniswapV3Interactor',
    outputs: [
      {
        internalType: 'contract IFissionUniswapV3Interactor',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInjector',
    outputs: [{ internalType: 'address', name: 'injector_', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'tokenAddr_', type: 'address' }],
    name: 'getPriceFeedTokenPrices',
    outputs: [
      { internalType: 'uint8', name: 'decimals', type: 'uint8' },
      { internalType: 'uint256', name: 'current', type: 'uint256' },
      { internalType: 'uint256', name: 'min', type: 'uint256' },
      { internalType: 'uint256', name: 'max', type: 'uint256' },
      { internalType: 'uint256', name: 'updatedAt', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'baseToken_', type: 'address' },
      { internalType: 'address', name: 'quoteToken_', type: 'address' },
    ],
    name: 'getStoredUniswapV3PoolFee',
    outputs: [{ internalType: 'uint24', name: '', type: 'uint24' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'baseToken_', type: 'address' },
      { internalType: 'address', name: 'quoteToken_', type: 'address' },
    ],
    name: 'getUniswapV3ObservationPrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: 'baseToken', type: 'address' },
          { internalType: 'address', name: 'quoteToken', type: 'address' },
          { internalType: 'uint24', name: 'poolFee', type: 'uint24' },
        ],
        internalType: 'struct IFissionUniswapV3Interactor.PoolData',
        name: 'poolData_',
        type: 'tuple',
      },
    ],
    name: 'getUniswapV3ObservationPrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: 'baseToken', type: 'address' },
          { internalType: 'address', name: 'quoteToken', type: 'address' },
          { internalType: 'uint24', name: 'poolFee', type: 'uint24' },
        ],
        internalType: 'struct IFissionUniswapV3Interactor.PoolData',
        name: 'poolData_',
        type: 'tuple',
      },
    ],
    name: 'getUniswapV3SpotPrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'baseToken_', type: 'address' },
      { internalType: 'address', name: 'quoteToken_', type: 'address' },
    ],
    name: 'getUniswapV3SpotPrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint32', name: 'defaultUniswapPeriod_', type: 'uint32' },
      {
        internalType: 'uint256',
        name: 'priceValidityPeriod_',
        type: 'uint256',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permissionManager',
    outputs: [
      {
        internalType: 'contract IPermissionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'priceValidityPeriod',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint32', name: 'defaultUniswapPeriod_', type: 'uint32' },
    ],
    name: 'setDefaultUniswapPeriod',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'contractsRegistryAddr_',
        type: 'address',
      },
      { internalType: 'bytes', name: '', type: 'bytes' },
    ],
    name: 'setDependencies',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'injector_', type: 'address' }],
    name: 'setInjector',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'priceValidityPeriod_',
        type: 'uint256',
      },
    ],
    name: 'setPriceValidityPeriod',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'baseToken_', type: 'address' },
      { internalType: 'address', name: 'quoteToken_', type: 'address' },
      { internalType: 'uint24', name: 'fee_', type: 'uint24' },
    ],
    name: 'setStoredUniswapV3PoolFee',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'tokenAddr_', type: 'address' },
      { internalType: 'uint256', name: 'current', type: 'uint256' },
      { internalType: 'uint256', name: 'min', type: 'uint256' },
      { internalType: 'uint256', name: 'max', type: 'uint256' },
    ],
    name: 'setTokenLatestPrices',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'tokenAddr_', type: 'address' },
      { internalType: 'uint8', name: 'decimals', type: 'uint8' },
      { internalType: 'uint256', name: 'current', type: 'uint256' },
      { internalType: 'uint256', name: 'min', type: 'uint256' },
      { internalType: 'uint256', name: 'max', type: 'uint256' },
    ],
    name: 'setupTokenPricesFeed',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
